import { ENDPOINTS } from "../../constant/routes";
import { request } from "../../services/requests";

/** A pilot seller's numbers, as on their "Your buyers" card on inflos.co.
 * Money is in `currency` (the seller's earnings currency). */
export interface BringBuyersStats {
  /** Buyers locked to the seller by a first payment */
  buyers: number;
  /** Signed up through the link or code, not paid yet */
  signups: number;
  /** Orders at 0% (or part 0%) commission */
  orders: number;
  sales: number;
  /** Commission the seller didn't pay */
  fees_saved: number;
  vouchers: number;
  /** Welcome vouchers the seller paid for */
  vouchers_paid: number;
  currency: string | null;
}

export interface BringBuyersSeller {
  /** false until marketplace migration 018 is applied */
  available: boolean;
  seller_id: string;
  is_seller: boolean;
  enabled: boolean;
  enabled_at: string | null;
  code: string | null;
  /** null when not in the pilot, or before the migrations */
  stats: BringBuyersStats | null;
  /** Only on PUT: whether anything changed */
  changed?: boolean;
}

export interface PilotSeller {
  seller_id: string;
  username: string | null;
  email: string | null;
  is_seller: boolean;
  enabled_at: string | null;
  code: string | null;
  stats: BringBuyersStats | null;
}

export interface PilotSellersResponse {
  available: boolean;
  sellers: PilotSeller[];
}

const sellerPath = (sellerId: string) => `${ENDPOINTS.BRING_BUYERS}/sellers/${encodeURIComponent(sellerId.trim())}`;

export const getPilotSellers = (token: string) => request(token).get<PilotSellersResponse>(`${ENDPOINTS.BRING_BUYERS}/sellers`);

export const getBringBuyersSeller = (sellerId: string, token: string) => request(token).get<BringBuyersSeller>(sellerPath(sellerId));

export const setBringBuyers = (sellerId: string, enabled: boolean, token: string) => request(token).put<BringBuyersSeller>(sellerPath(sellerId), { enabled });
